<template>
    <div class="main-layout">
        <div 
            v-show="showTablature" 
            class="tab-bar" 
            :style="tabBarStyle"
        >
            <TablatureBar ref="tablature"/>
        </div>
        <div 
            v-show="showDivider" 
            class="divider" 
            @mousedown="startDrag"
        ></div>
        <div 
            v-show="showSidebar" 
            class="side-bar" 
            :style="sideBarStyle"
        >
            <SideBar ref="sidebar"/>
        </div>
    </div>
</template>

<script>
import TablatureBar from './TablatureBar.vue';
import SideBar from './SideBar.vue';

export default {
    components: {
        TablatureBar,
        SideBar
    },
    data() {
        return {
            tablatureWidth: 75,
            sideBarWidth: 35,
            isDragging: false,
            startX: 0,
            initialTablatureWidth: 0
        };
    },
    computed: {
        layoutMode() {
            return this.$store.state.layoutMode;
        },
        showTablature() {
            return ['split', 'tablature'].includes(this.layoutMode);
        },
        showSidebar() {
            return ['split', 'sidebar'].includes(this.layoutMode);
        },
        showDivider() {
            return this.layoutMode === 'split';
        },
        tabBarStyle() {
            return {
                width: this.layoutMode === 'split' ? this.tablatureWidth + '%' : '100%'
            };
        },
        sideBarStyle() {
            return {
                width: this.layoutMode === 'split' ? this.sideBarWidth + '%' : '100%'
            };
        }
    },
    mounted() {
        // 监听导出事件
        this.$on("export-svg", this.exportSvg);
        this.$on("export-pdf", this.exportPdf);
        this.$on("export-txt", this.exportTxt);
        this.$on("import-txt", this.importTxt);
        this.$on("update-notation", this.updateNotation);
    },
    beforeDestroy() {
        this.$off("export-svg", this.exportSvg);
        this.$off("export-pdf", this.exportPdf);
        this.$off("export-txt", this.exportTxt);
        this.$off("import-txt", this.importTxt);
        this.$off("update-notation", this.updateNotation);
    },
    methods: {
        startDrag() {
            this.isDragging = true;
            this.startX = event.clientX;
            this.initialTablatureWidth = this.tablatureWidth;

            document.addEventListener("mousemove", this.onDrag);
            document.addEventListener("mouseup", this.stopDrag);
        },
        onDrag(event) {
            if (this.isDragging) {
                const totalWidth = this.$el.clientWidth;

                const deltaX = event.clientX - this.startX;

                const newTablatureWidth = this.initialTablatureWidth + (deltaX / totalWidth) * 100;
                this.tablatureWidth = Math.max(50, Math.min(90, newTablatureWidth));
                this.sideBarWidth = 100 - this.tablatureWidth;
            }
        },
        stopDrag() {
            this.isDragging = false;
            document.removeEventListener("mousemove", this.onDrag);
            document.removeEventListener("mouseup", this.stopDrag);
        },
        exportSvg() {
            // 调用 TablatureBar 的导出方法
            this.$refs.tablature.exportSvg();
        },
        exportPdf() {
            // 调用 TablatureBar 的导出方法
            this.$refs.tablature.exportPdf();
        },
        exportTxt() {
            // 调用 SideBar 的导出方法
            this.$refs.sidebar.exportTxt();
        },
        importTxt(content) {
            // 调用 SideBar 的导入方法
            this.$refs.sidebar.setContent(content);
        },
        updateNotation(content) {
            this.$refs.sidebar.setContent(content);
            this.$refs.sidebar.parseInput(content);
        }
    }
};
</script>

<style scoped>
.main-layout {
    display: flex;
    height: calc(100vh - 80px);
    overflow: hidden;
}

.tab-bar {
    height: 100%;
    transition: width 0.3s ease;
}

.side-bar {
    height: 100%;
    transition: width 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
}

.divider {
    width: 1.5px;
    background-color: #d3d3d3;
    cursor: ew-resize;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divider-arrow {
    font-size: 12px;
    color: #333;
    padding: 0 2px;
    user-select: none;
}
</style>
